import { usingPost } from '@ocean/api'
import { LoginWithSsoModel } from '../types'

export const loginWithSso = (ssoLoginModel: LoginWithSsoModel) =>
  usingPost('Session/authenticationWithSso', ssoLoginModel, { useProxy: true })
